import { createActions } from "reduxsauce";

const { Types, Creators } = createActions({
  consultarUsuarios: ["payload"],
  consultarUsuariosLoading: null,
  consultarUsuariosSuccess: ["consultarUsuariosData"],
  consultarUsuariosFailure: ["consultarUsuariosError"],

  obtenerRecursos: ["payload"],
  obtenerRecursosLoading: null,
  obtenerRecursosSuccess: ["obtenerRecursosData"],
  obtenerRecursosFailure: ["obtenerRecursosError"],

  asignarRol: ["payload"],
  asignarRolLoading: null,
  asignarRolSuccess: ["asignarRolData"],
  asignarRolFailure: ["asignarRolError"],

  removerRol: ["payload"],
  removerRolLoading: null,
  removerRolSuccess: ["removerRolData"],
  removerRolFailure: ["removerRolError"],

  obtenerUsuario: ["payload"],
  obtenerUsuarioLoading: null,
  obtenerUsuarioSuccess: ["obtenerUsuarioData"],
  obtenerUsuarioFailure: ["obtenerUsuarioError"],
});

export { Types };

export default Creators;
